import styles from "@/components/donate-popup.module.css";
import PopupShell from "@/components/popup-shell";
import { globals } from "@/globals";
import { closePopup } from "@/utils";
import { faAlipay } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "i18next";
import { JSX } from "react";

interface DonatePopupProps {
	isShown: boolean;
}

function DonatePopup({ isShown }: DonatePopupProps): JSX.Element {
	const closeDonatePopup = (): void => {
		closePopup("donate");
	};

	return (
		<PopupShell
			isPureWhite={true}
			isShown={isShown}
			onClose={closeDonatePopup}
			title={t("donateUs")}
		>
			<p className={styles["description"]}>{t("donateDescription")}</p>
			{globals.isMobile && (
				<>
					<a
						className={styles["alipay-link"]}
						href="https://qr.alipay.com/fkx13766h1geajcuk6kta68"
						rel="noreferrer"
						target="_blank"
					>
						<FontAwesomeIcon icon={faAlipay} />
						{t("useAlipay")}
					</a>
					<div className={styles["qr-code-tip"]}>
						{t("donateQrCodeTip")}
					</div>
				</>
			)}
			<picture className={styles["qr-code-image"]}>
				<source
					srcSet="https://assets.retiehe.com/alipay.webp"
					type="image/webp"
				/>
				<img
					src="https://assets.retiehe.com/alipay.jpg"
					alt={t("alipayQrCode")}
				/>
			</picture>
			<picture className={styles["qr-code-image"]}>
				<source
					srcSet="https://assets.retiehe.com/wechatpay-lime.webp"
					type="image/webp"
				/>
				<img
					src="https://assets.retiehe.com/wechatpay-lime.jpg"
					alt={t("wechatPayQrCode")}
				/>
			</picture>
		</PopupShell>
	);
}

export default DonatePopup;
